<script>
    import { onMount } from "svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import Router from "../../router.js";
    import Modal from "./modalconfirm.svelte";
    import Select from "./select.svelte";
    import Spinner from "./spinner.svelte";
    import { AuthUser } from "../../store.js";

    export let showModal = true;  
    let estabs=[];
    let schools=[];
    let groups=[];
    let noOfItems;
    let selectedGroup;
    let selectedSchool;
    let disableConfirm = false;
    let isAtomwide = false;
    let isDoncaster = false;
    let searchTerm="";
    let errorMsg ='';
    let isButtonLoading=false;
    let showConfirmButton=false;
    let isPageLoading=true;
    let sortedSchools;
    $:{
        showConfirmButton = !isPageLoading;
    }
    onMount(async () => {
       
        
        
        if ($AuthUser){     
            isAtomwide = $AuthUser.universalId.endsWith(".000") && $AuthUser.mainSchoolId==18854;
            isDoncaster = $AuthUser.universalId.endsWith(".000") && $AuthUser.mainSchoolId==91669;
            // console.log('AuthUser',$AuthUser)
            $AuthUser.associatedSchools.forEach( s => s.estab = s.schoolDisplayName);
            estabs = $AuthUser.associatedSchools;
            //console.log('estabs',estabs)
        }
      
       //selectedGroup = (isAtomwide && selectedGroup == undefined)?169:$AuthUser.sGroupId;
       if(isAtomwide)
        selectedGroup = $AuthUser.sGroupId;       
        selectedSchool =$AuthUser.schoolId;
        // console.log('selectedGroup::',selectedGroup)
        // console.log('selectedSchool::',selectedSchool)
      
        if(isAtomwide)
        await getGroups();
        else if(isDoncaster)
            await getLas();
        schools=estabs

        sortedSchools = estabs.slice();
        
        sortedSchools.sort(function(a, b) {
            return a.estab.localeCompare(b.estab);
        });

        schools = sortedSchools;

        isPageLoading = false;
    });

    $: {
        disableConfirm = noOfItems < 1;        
    }
   
    const search=()=>{       
      schools=estabs.filter(
      i =>  i.estab.toLowerCase().indexOf(searchTerm.toLowerCase() ) >= 0);

      noOfItems = schools.length;
      if(schools.length < 1)      
      schools.push({"estab":"No items found"})
    }

    const changeToSelectedEstablishment = async () => {
        isButtonLoading = true;               
        if (selectedSchool == null || selectedSchool == "") {
            errorMsg = "Please select establishment";  
            isButtonLoading = false;       
            return false;   
        }
        
        let resp = await wrappedFetch(
            `/api/user/ChangeEstablishment?schoolId=${selectedSchool}&groupId=${selectedGroup}`,
            {
                method: "post",
            }
        );
        let response = await resp.json();
        AuthUser.set(response.authUser);
        showModal = false;
        isButtonLoading = false;
        Router.route("/app/");
    };

    const getGroups = async() => {
        let resp = await wrappedFetch(`/api/uso/GetGroupsForWeb`, {
            method: "post",
        });
        groups = await resp.json();
        // console.log('result',groups)
        if(isAtomwide && selectedGroup == 0)
        selectedGroup = groups[0].groupId;

        await getEstablishments(selectedGroup);
     //await getEstablishments(groups[0].sGroupID);

    }
   

    
    const getEstablishments = async(sgid) => {      
  
        let resp = await wrappedFetch(`/api/uso/GetEstablishmentsForWeb?sgid=${sgid}`, {
            method: "post",
        });
        let result = await resp.json();   
        schools=result;
        estabs=schools;  
  
        if(selectedSchool == undefined)     
        {           
        selectedSchool = schools[0].schoolId;
        }
     
    }

    const getLas = async () => {        
        let resp = await wrappedFetch(`/api/account/GetEstablishmentsWithSubscription`, {
            method: "post",
        });
        estabs = await resp.json();      
      //  selectedLa = las[0].sGroupID;
      //  await getSchools();
        // las=[{id:1,name:"Barnet"},{id:2,name:"Bromley"},{id:3,name:"Barking & Dagenham"},{id:4,name:"Royal Borough of Greenwich"},{id:5,name:"Bexley"}];
    };

    // const getSchools = async () => {       
    //     let resp = await wrappedFetch(
    //         `/api/uso/GetEstablishmentsWithSubscription?sgid=${selectedLa}`,
    //         {
    //             method: "post",
    //         }
    //     );
    //     let result = await resp.json();
    //     schools = result.map((r) => {
    //         r.estab = `${r.estab}(${r.fullDfES})`;
    //         return r;
    //     });
    //     selectedSchool =
    //         schools && schools.length > 0 ? schools[0].schoolID : null;
    // };

</script>

<Modal
    bind:showModal  
    sizeClass=""
    targetClass="schoolModal"
    buttonText="Change"
    buttonClass="btn-primary"
    buttonStyle={"width:82px;height:35px;"}
    bind:showConfirmButton={showConfirmButton}
    bind:disabled={disableConfirm}
    bind:isButtonLoading={isButtonLoading}
    on:confirm={async () => {
        await changeToSelectedEstablishment();        
    }}>
    <div slot="header">
        <h4 class="title">Change Establishment</h4>
    </div>
    <!-- <div slot="content" style="min-height:115px"> -->
        <div slot="content">
        {#if isPageLoading}
        <Spinner marginTop={"50px"}/>
        {:else}
        {#if isAtomwide}
            <div class="form-group">
               
                <!-- <label for="establishments">Groups/LA:</label>    -->
                <!-- <select
                bind:value={selectedGroup}
                on:change={async()=>await getEstablishments(selectedGroup)}
                class="form-control"              
                name="la"
                required>
           
                {#each groups as la}
                    <option value={la.groupId}>
                        {la.name}
                    </option>
                {/each}
            </select>
       -->
             <Select
                    bind:selected={selectedGroup}
                    items={groups}
                    value={'groupId'}
                    label="name"                  
            on:change={async()=>await getEstablishments(selectedGroup)}/>
      
            </div>
            {/if}
            <div class="form-group">
             
                <!-- <label for="establishments">Associated establishments:</label>    -->
                      
                <Select
                    bind:selected={selectedSchool}
                    items={schools}
                    value={'schoolId'}
                    label="estab"/> 
            </div>

            <!--The code commented below is for filtering school list which is functioning but is turned off as it does not seem to be required for now.It could be turned on later when there are too many Nimbus subscribed schools-->
            <!-- <div class="form-group">
                <input type="text" class="form-control" bind:value={searchTerm} placeholder="Type here to filter the above drop-down list of establishments" on:keyup={search}>
                {#if noOfItems != null} <span style="display:inline-block;color:Red;font-size:Small;font-style:italic;width:200px;">{noOfItems} items found.</span>{/if}
            </div> -->
        
            {#if errorMsg!=''}
                <br>
                <span class="text-danger">{errorMsg}</span>
            {/if} 
        {/if}
    </div>
</Modal>
